import { render, staticRenderFns } from "./HeadNavBarMini.vue?vue&type=template&id=452ea570&"
import script from "./HeadNavBarMini.vue?vue&type=script&lang=js&"
export * from "./HeadNavBarMini.vue?vue&type=script&lang=js&"
import style0 from "./HeadNavBarMini.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports